/* *
 * ========================================================================
 * Vortex Solution
 * ========================================================================
 * */

// Includes the custom Modernizr build based on the configurations set in .modernizrrc
require('Modernizr'); // eslint-disable-line import/no-extraneous-dependencies
require('nodelist-foreach-polyfill');
require('element-qsa-scope');
require('./main/dropdown-menu');
require('./main/mobile-menu');
require('./main/navbar-sticky');
require('./main/user-is-tabbing');
require('./main/forms');
require('./main/search-modal');
require('./main/popular-request');
require('./main/breadcrumbs');
require('./main/partner-slider');
require('./main/alert-message');
require('./main/btn-animation');
require('./main/iframe-icon');
require('./main/share');
require('./main/form-login');
require('./main/facetwp-filters');
